import { P } from '@farewill/ui'
import { ACTIVE_BRANDS } from 'config/brands'
import GroupedCheckbox from 'components/grouped-checkbox'

const BrandFilter = () => {
  return (
    <>
      <P strong margin={[0, 0, 'XS']} size="S">
        Brand
      </P>
      {ACTIVE_BRANDS.map((brand) => (
        <GroupedCheckbox
          key={`${brand.value}-filter`}
          label={brand.label as string}
          value={brand.value as string}
          groupName="brandIds"
        />
      ))}
    </>
  )
}

export default BrandFilter
